<template>
    <div class="chart" :style="{height:height}">
        <!-- 词云公共组件 -->
        <v-chart :options="worldCloud" id="echart20" auto-resize></v-chart>
        <div
                class="no-chart-data"
                style="color:#D3D3D3;font-size:20px;"
                v-show="isNodata"
        >Temporarily no data
        </div>
    </div>
</template>

<script>
require('echarts-wordcloud')

export default {
  props: ['wordData', 'height', 'isNodata', 'noSaveAsImage', 'sizeRange'],
  mounted () {
    //this.worldCloud.series[0].data = this.wordData;
    this.setOptions()
    window.addEventListener('resize', () => {
      this.myChart13.resize()
    })
  },
  data () {
    return {
      worldCloud: {},
      myChart13: '',
    }
  },
  methods: {
    setOptions () {
      let echarts = require('echarts')
      let newResultData = this.$lodash.cloneDeep(this.wordData)

      this.worldCloud = this.getOptions(newResultData)
      this.myChart13 = echarts.init(document.getElementById('echart20'))
    },
    getOptions (newResultData) {
      return {
        toolbox: {
          feature: {
            saveAsImage: {
              show: !this.noSaveAsImage,
              title: 'Save as picture'
            }
          },
          right: '5%'
        },
        // title: {
        //   show: newResultData.length === 0,
        //   textStyle: {
        //     color: "LightGrey",
        //     fontSize: 20
        //   },
        //   text: "Temporarily no data",
        //   left: "center",
        //   top: "center"
        // },
        title: {
          text: 'Hot-word Cloud',
          show: false
        },
        tooltip: {
          show: true
        },
        series: [
          {
            // name: "舆情信息",
            width: '500%',
            height: '400%',
            type: 'wordCloud',
            size: ['200%', '200%'],
            // textRotation: [0, 0],  // 版本问题 控制文字方向
            rotationRange: [0, 0], // 版本问题 控制文字方向
            shape: 'circle',
            sizeRange: this.sizeRange ? this.sizeRange : [20, 70],

            // autoSize: {
            //   enable: true,
            //   minFontSize: 30, 
            //   maxFontSize: 60
            // },
            textStyle: {
              normal: {
                color: function () {
                  const barColor = ['#5C89FF', '#7C6AF2', '#C95FF2', '#FF6383', '#FF9F40', '#FFCB48', '#31DC72', '#26DAD0', '#5CB3FF', '#8290FF', '#EF6BBB', '#FF7979', '#EBE300', '#26E7C7', '#13BAED']

                  return barColor[parseInt(Math.random() * 10)]
                  // return (
                  //   "rgb(" +
                  //   [
                  //     Math.round(Math.random() * 220),
                  //     Math.round(Math.random() * 220),
                  //     Math.round(Math.random() * 220)
                  //   ].join(",") +
                  //   ")"
                  // );

                }
              },
              fontFamily: 'RCB'

              // 高亮
              /*  emphasis: {
                shadowBlur: 10,
                shadowColor: "#333"
              } */
            },
            data: newResultData
          }
        ]
      }
    }
  },
  watch: {
    wordData (newValue) {
      //this.worldCloud.series[0].data = [];
      // this.worldCloud.series[0].data = newValue;
      this.setOptions()
    }
  }
}
</script>

<style scoped>
    .echarts {
        width: 100%;
        height: 100%;
    }

    .chart {
        position: relative;
    }

    .chart .no-chart-data {
        width: 300px;
        font-size: 25;
        font-weight: 600;
        position: absolute;
        left: 50%;
        top: 50%;
        transform: translate(-50%, -50%);
    }
</style>
